const scheduledNotifications = new Set(); // Stores scheduled reminder IDs

const scheduleReminderNotifications = (reminders) => {
  reminders?.forEach((reminder) => {
    if (scheduledNotifications.has(reminder._id)) return; // Skip if already scheduled

    const reminderTime = new Date(reminder.reminderDateTime).getTime();
    const currentTime = Date.now();
    const timeDiff = reminderTime - currentTime;

    if (timeDiff > 0) {
      scheduledNotifications.add(reminder._id);
      setTimeout(() => {
        showNotification(reminder);
        scheduledNotifications.delete(reminder._id); // Remove after showing
      }, timeDiff);
    }
  });
};

navigator.serviceWorker.addEventListener("message", (event) => {
  if (event.data?.type === "SNOOZE_REMINDER") {
    const { reminder } = event.data;

    if (reminder) {
      // console.log("Snoozing reminder on client side...");
      setTimeout(() => {
        navigator.serviceWorker.getRegistration().then((registration) => {
          registration?.showNotification("🔔 Reminder Snoozed!", {
            body: `📝 ${reminder.leadName}: ${reminder.reminderMessage}`,
            icon: "/assets/img/bsm/1.png", // ✅ Fixed path
            image: "/reminder-banner.png",
            badge: "/badge-icon.png",
            requireInteraction: true,
            vibrate: [200, 100, 200],
            actions: [
              { action: "snooze", title: "⏳ Snooze Again" },
              { action: "dismiss", title: "❌ Dismiss" },
            ],
            data: reminder,
          });
        });
      }, 5 * 60 * 1000); // 5 mins snooze
    }
  }
});

const showNotification = (reminder) => {
  if (Notification.permission === "granted") {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification("🔔 Reminder Alert!", {
        body: `📝 ${reminder.leadMetaDetails.leadName}: ${reminder.reminderMessage}`,
        icon: "/assets/img/bsm/1.png", // Small icon (app logo)
        image: "/reminder-banner.png", // Large banner image
        badge: "/badge-icon.png", // Small badge icon (for mobile)
        requireInteraction: true, // Keep notification visible until dismissed
        vibrate: [200, 100, 200], // Vibration pattern
        actions: [
          { action: "snooze", title: "⏳ Snooze for 5 mins" },
          { action: "dismiss", title: "❌ Dismiss" },
        ],
        data: {
          leadId: reminder.leadId,
          leadName: reminder.leadMetaDetails.leadName,
          reminderMessage: reminder.reminderMessage,
          module: reminder.module,
          baseUrl: process.env.REACT_APP_BASE_URL,
        },
      });
    });
  }
};

export { scheduleReminderNotifications };
